import React from 'react';

/**
 * PiChevronBigLeftStroke icon from the stroke style in arrows-&-chevrons category.
 */
interface PiChevronBigLeftStrokeProps extends React.SVGProps<SVGSVGElement> {
  size?: number;
  color?: string;
  className?: string;
  ariaLabel?: string;
}

export default function PiChevronBigLeftStroke({
  size = 24,
  color,
  className,
  ariaLabel = 'chevron-big-left icon',
  ...props
}: PiChevronBigLeftStrokeProps): JSX.Element {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      fill="none"
      stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{color: color || "currentColor"}}
      
      role="img"
      aria-label={ariaLabel}
      {...props}
    >
      <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 18a30.6 30.6 0 0 1-5.817-5.49.8.8 0 0 1 0-1.02A30.6 30.6 0 0 1 15 6" fill="none"/>
    </svg>
  );
}
